import React from "react";
import PrintField from "../../shared/PrintField";
import "./MeetingInvitationEN.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const MeetingInvitationEN = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper inv-en" ref={ref}>
        {/* Top: COMPANY/ADDRESS (left) + Dated (right) */}
        <div className="en-top">
          <div className="en-top-left">
            <div className="inv-bold">COMPANY</div>
            <div className="inv-bold" style={{ marginTop: 10 }}>
              ADDRESS
            </div>
          </div>

          <div className="en-top-right inv-bold">
            Dated :{" "}
            <InputField
              className="inv-line inv-line-dotted"
              style={{ width: "140px" }}
              spellCheck={false}
            />
          </div>
        </div>

        {/* Subject / To */}
        <div className="en-pairs">
          <div className="en-pair-row">
            <div className="en-left inv-bold">
              <span>Subject</span>
              <span className="en-colon">:</span>
            </div>
            <div className="en-right inv-bold">
              Invitation to the Annual General Meeting of Shareholders No.{" "}
              <InputField
                className="inv-line inv-line-dotted"
                style={{ width: "120px" }}
                spellCheck={false}
              />
            </div>
          </div>

          <div className="en-pair-row">
            <div className="en-left inv-bold">
              <span>To</span>
              <span className="en-colon">:</span>
            </div>
            <div className="en-right inv-bold">
              Shareholders of{" "}
              <InputField
                className="inv-line inv-line-dotted"
                style={{ width: "180px" }}
                spellCheck={false}
              />
            </div>
          </div>
        </div>

        {/* Body Paragraph 1 (Justified + Indent) */}
        <p className="inv-paragraph inv-bold">
          By the Board of Directors of the Company. A resolution to the General
          Meeting of Shareholders No.{" "}
          <InputField
            className="inv-line inv-line-dotted"
            style={{ width: "120px" }}
            spellCheck={false}
          />{" "}
          On{" "}
          <InputField
            className="inv-line inv-line-dotted"
            style={{ width: "100px" }}
            spellCheck={false}
          />{" "}
          at{" "}
          <InputField
            className="inv-line inv-line-dotted"
            style={{ width: "100px" }}
            spellCheck={false}
          />{" "}
          am. At company&apos;s office{" "}
          <InputField
            className="inv-line inv-line-dotted"
            style={{ width: "180px" }}
            spellCheck={false}
          />
        </p>

        {/* Agenda header */}
        <div className="inv-paragraph inv-bold" style={{ textIndent: "40px" }}>
          The agenda is as follows.
        </div>

        {/* Agenda Items */}
        <div className="en-agenda">
          <div className="en-agenda-item inv-bold">
            Agenda 1 : Approval of the minutes of the Extraordinary General
            Shareholders’ Meeting No.{" "}
            <InputField
              className="inv-line inv-line-dotted"
              style={{ width: "70px" }}
              spellCheck={false}
            />{" "}
            /(year)
          </div>
          <div className="en-agenda-item inv-bold">
            Agenda 2 : To consider and approve the financial statements for the
            year{" "}
            <InputField
              className="inv-line inv-line-dotted"
              style={{ width: "90px" }}
              spellCheck={false}
            />{" "}
            .
          </div>
          <div className="en-agenda-item inv-bold">
            Agenda 3 : To consider the appointment of the auditor.
          </div>
          <div className="en-agenda-item inv-bold">
            Agenda 4 : To consider other matters (if any)
          </div>
        </div>

        {/* Closing Paragraph (Justified + Indent) */}
        <p className="inv-paragraph inv-bold" style={{ marginTop: "30px" }}>
          Therefore, they would like to attend the shareholder meeting date,
          time and place thereof. If you are unable to attend the meeting in
          person. Please make a proxy to attend the meeting. Thank you very much.
        </p>

       {/* Signature Section */}
        <div className="en-sign">
          {/* เส้นจุดสำหรับเซ็นชื่อ (ยังมีเส้นจุด) */}
          <InputField
            className="inv-line inv-line-dotted"
            style={{ width: "220px" }}
            spellCheck={false}
            optional
          />
          
          <div className="inv-bold">
            {/* ในวงเล็บ เป็นช่องว่างพิมพ์ได้ แต่ไม่มีเส้น (border: none) */}
            ( <InputField
              className="inv-line" 
              style={{ 
                width: "240px", 
                textAlign: "center",
                border: "none",        /* บังคับไม่ให้มีเส้น */
                background: "transparent" /* พื้นหลังโปร่งใส */
              }}
              spellCheck={false}
            /> )
          </div>

          <div className="inv-bold">Managing Director</div>
        </div>
      </div>
    </div>
  );
});

export default MeetingInvitationEN;
